module.exports = __webpack_public_path__ + "img/EXTERIOR-VITARA-4.65017092.jpg";